export default __webpack_public_path__ + "static/media/copyIcon.14a1de97.webp";